<mat-dialog-content>
    <mat-icon *ngIf="icon" style="margin-right:0.25em;" color="warn">{{icon | lowercase}}</mat-icon>
    <span style="white-space:pre-line;" [innerHtml]="message"></span>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onCloseClick()" mat-dialog-close
        tabindex="-1">{{buttonText}}</button>
</mat-dialog-actions>